import React from 'react';
import { util } from '../Util';
import moment from 'moment';
import { ApiRoutes } from '../ApiRoutes';
import { MomentDateFormat } from '../MomentDateFormat';
import { Button, Table } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCopy,
    faExternalLink,
    faFileInvoice,
} from '@fortawesome/free-solid-svg-icons';
import { SubHeading, toasty } from '../common/forms/FormElements';
import { CircularProgress } from '@mui/material';

export class BrokerDateHashCodeDisplay extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            brokerDateHashCodes: [],
            asOfDate: moment().add(-30, 'day'),
            loading: true,
        };
    }

    componentDidMount() {
        this.populateState();
    }

    async populateState() {
        await this.fetchBrokerDateHashCodes();
    }

    fetchBrokerDateHashCodes = async () => {
        const { brokerId } = this.props;
        const { asOfDate } = this.state;

        this.setState({ loading: true });

        const queryDate = moment(asOfDate).format(
            MomentDateFormat.ApiUrlRequest
        );

        const brokerDateHashCodes = await util.fetch.js(
            ApiRoutes.brokerDateHashCode.get(brokerId, queryDate)
        );

        this.setState({ brokerDateHashCodes, loading: false });
    };

    onFetchMoreClick = () => {
        const { asOfDate, loading } = this.state;

        if (loading) {
            return;
        }

        const backOneYear = moment(asOfDate).add(-1, 'year').toDate();

        this.setState({ asOfDate: backOneYear }, () =>
            this.fetchBrokerDateHashCodes()
        );
    };

    onCopyClick = (brokerDateHashCode) => {
        if (!brokerDateHashCode || !brokerDateHashCode.hashCode) {
            return;
        }

        navigator.clipboard.writeText(this.toExternalUrl(brokerDateHashCode));

        toasty.success(
            'Link Copied',
            "The broker's shared link has been copied to your clipboard."
        );
    };

    toExternalUrl = (brokerDateHashCode) => {
        if (!brokerDateHashCode || !brokerDateHashCode.hashCode) {
            return null;
        }

        return `${window.origin}/broker/${brokerDateHashCode.hashCode}`;
    };

    render() {
        const { brokerId } = this.props;
        const { brokerDateHashCodes, asOfDate, loading } = this.state;

        if (!brokerId || !brokerDateHashCodes || !brokerDateHashCodes.length) {
            return null;
        }

        if (loading) {
            return <CircularProgress />;
        }

        return (
            <div>
                <div>
                    <SubHeading>Brokers - Shared Links</SubHeading>
                </div>
                <div>
                    <Button
                        type="button"
                        onClick={this.onFetchMoreClick}
                        color="secondary"
                        className="w-100 mt-2 mb-2"
                    >
                        <FontAwesomeIcon
                            icon={faFileInvoice}
                            className="mr-1"
                        />{' '}
                        Effective as of{' '}
                        {moment(asOfDate).format(
                            MomentDateFormat.MonthDayYearSlashesLeading
                        )}
                        . Click to query further back in time.
                    </Button>
                </div>
                <div>
                    <Table className="diceware-table" striped>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {brokerDateHashCodes.map((bdd) => (
                                <tr key={bdd.id}>
                                    <td className="align-middle">
                                        <Button
                                            type="button"
                                            color="primary"
                                            outline
                                            onClick={() =>
                                                this.onCopyClick(bdd)
                                            }
                                        >
                                            <FontAwesomeIcon
                                                icon={faCopy}
                                                className="mr-1"
                                            />
                                            Copy URL for{' '}
                                            {moment(bdd.date).format(
                                                MomentDateFormat.WeekDayNameAndDate
                                            )}
                                        </Button>
                                    </td>
                                    <td className="align-middle">
                                        <a
                                            href={this.toExternalUrl(bdd)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <FontAwesomeIcon
                                                icon={faExternalLink}
                                                className="mr-1"
                                            />
                                            Click to visit broker view.
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }
}
